import { IPromise } from 'angular';
import { IResult } from '../ServerApi/types/IResponse';
import * as _ from 'underscore';

import { ResultHelper } from '../helpers/ResultHelper';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { DeleteOrphanedManagedKeychainRequest } from '../ServerApi/requests/DeleteOrphanedManagedKeychainRequest';
import { openConfirmActionDialog } from '../services/ReactConfirmActionDialog';
import { ReactConfirmActionStringBody, ReactConfirmActionStringBodyProps } from '../services/ReactConfirmActionStringBody';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';

export class ClearOrphanedManagedKeychainAction {

  public static $inject = [
    'ServerService'
  ];

  constructor(
    private serverService: ServerService
  ) { }

  public confirmDeleteOrphanedManagedKeychain(): IPromise<any> {
    const confirmActionDialogInstance = openConfirmActionDialog<ReactConfirmActionStringBodyProps, any, IResult>({
      title: Messages.clearOrphanedManagedKeychain(),
      bodyComponent: ReactConfirmActionStringBody,
      initialBodyProps: {
        message: Messages.clearOrphanedManagedKeychainConfirmMessage()
      },
      actionName: Messages.clearOrphanedManagedKeychainConfirmButton(),
      initialDialogState: {},
      isActionDelete: true,
      action: () => {
        return this.serverService.sendRequest(new DeleteOrphanedManagedKeychainRequest({}));
      }
    });

    confirmActionDialogInstance.result.then((result: any) => {
      if (ResultHelper.hasErrors(result)){
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainError() });
      }
      else{
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainSuccess() });
      }
      confirmActionDialogInstance.close();
    });

    return confirmActionDialogInstance.result;
  }

}

Module.instance().service('ClearOrphanedManagedKeychainAction', ClearOrphanedManagedKeychainAction);